import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx";
import LoadingSpinner from '../spinner/loading.component.jsx'
import SendEmailModal from "../email/sendemail.component.jsx";
import ReactTooltip from "react-tooltip";
import {
    FormattedMessage,
} from 'react-intl'

class SendSchedulingPageButton extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            schedulingPageTemplate: null,
            proposalScheduling: null,
            schedulingPages: [],
            invoice: this.props.invoice,
            order: this.props.order,
            quote: this.props.quote,
            invoiceId: this.props.invoiceId || "",
            orderId: this.props.orderId || "",
            quoteId: this.props.quoteId || "",
            typeOfDocument: this.props.typeOfDocument,
            pagesLoading: true,
            isActive: true
        }
        this.tooltipRef = React.createRef()
        this.sendProposal = this.sendProposal.bind(this)
        this.sendEmail = this.sendEmail.bind(this)
        this.getDocument = this.getDocument.bind(this)
        this.getDocumentId = this.getDocumentId.bind(this)
        this.getActiveSchedulingPages = this.getActiveSchedulingPages.bind(this)
    }


    componentDidMount() {
        AppContext.getApiClient().get('/templates/send-scheduling-page/template').then(t => {
            this.setState({
                schedulingPageTemplate: t,
            })
        })

        const postData = {
            keywords: '*',
            objects: ['scheduling-pages'],
            fields: [
                'identifier',
                'title',
                'titleKeyword',
                'titleAnalyzed'],
            pageSize: 10,
            activePage: 1,
            totals: [],
            lightResult: true,
            sortAsc: true,
            sortByField: "titleKeyword",
            filters: { availableFromKeyword: [this.state.typeOfDocument] },
        }
        AppContext.getApiClient().post('/listing/search', postData).then(res => {
            this.setState({
                schedulingPages: res.data,
                pagesLoading: false
            })
        })
    }

    sendProposal(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail) {
        let proposal = this.state.proposalScheduling
        AppContext.getApiClient()
            .post('/proposals/' + proposal.attributes.hash + '/send-by-email', {
                subject: subject,
                toEmail: toEmail,
                ccEmail: ccEmail,
                content: content,
                buttonLabel: buttonLabel,
                fromEmail: fromEmail,
                bccEmail: bccEmail,
                invoiceId: this.state.invoiceId,
                orderId: this.state.orderId,
                quoteId: this.state.quoteId,
                isActive: true
            }).then(res => {
                this.tooltipRef.current.dispatchEvent(new Event("showTooltip"))
                setTimeout(ReactTooltip.hide, 4000)
            })
    }

    getDocument() {
        if (this.state.invoice) {
            return this.state.invoice
        }
        if (this.state.order) {
            return this.state.order
        }
        if (this.state.quote) {
            return this.state.quote
        }
        return null
    }

    getDocumentId() {
        if (this.state.invoice) {
            return this.state.invoiceId
        }
        if (this.state.order) {
            return this.state.orderId
        }
        if (this.state.quote) {
            return this.state.quoteId
        }
        return ""
    }

    sendEmail(id) {
        let scPageSelected = this.state.schedulingPages.find(sp => sp.id == id)
        let attr = this.state.schedulingPageTemplate ? this.state.schedulingPageTemplate.attributes : {}
        let document = this.getDocument()
        if (scPageSelected && scPageSelected.proposalHash && attr) {
            AppContext.getApiClient().get('/proposals/' + scPageSelected.proposalHash).then(res => {
                let modal = <SendEmailModal
                    toEmail={document && document.attributes.contact ? document.attributes.contact.attributes.email : ""}
                    lastEmailSubject={scPageSelected.sendSchedulingPageEmailSubject || attr.subject}
                    lastEmailContent={scPageSelected.sendSchedulingPageEmailContent  || attr.content}
                    lastEmailButtonLabel={scPageSelected.sendSchedulingPageEmailButtonLabel || attr.buttonLabel}
                    title={<FormattedMessage
                        id="scheduling_page.send_email.modal.title"
                        defaultMessage="Send scheduling page email"
                    />}
                    onSubmit={this.sendProposal}
                    onClose={this.props.handleCloseModal}
                    proposalType={'scheduling-page'}
                    templateKey={'send-scheduling-page'}
                />
                this.props.handleSendEmailModal(modal)
                this.setState({
                    proposalScheduling: res,
                    isActive: true
                })
            })
        }

    }

    getActiveSchedulingPages() {
        return this.state.schedulingPages.filter(sp => sp.status == "active")
    }

    render() {
        const documentId = this.getDocumentId()
        let activeSchedulingPages = this.getActiveSchedulingPages()
        return (
            activeSchedulingPages && activeSchedulingPages.length > 0 && (this.state.pagesLoading ?
                <button disabled={true} className={"btn btn-primary"}>
                    <LoadingSpinner className={"px-4 mx-4"} height={20} />
                </button> :
                <div className="btn-group mr-2 mb-2" role="group">
                    <button id="btnGroupScheduling" type="button"
                        className={"btn btn-outline-primary " + (activeSchedulingPages.length > 0 ? "dropdown-toggle" : "disabled")} data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false"
                        ref={this.tooltipRef} data-tip={"tooltip"} data-for={"sendSchedulingPage" + documentId}>
                        <Icon value={"envelope"} className={"mr-1"} />
                        <FormattedMessage
                            id="scheduling_page.analytics.send_btn"
                            defaultMessage="Send scheduling page"
                        />
                    </button>
                    <ReactTooltip place={"top"} id={"sendSchedulingPage" + documentId} type="success" event="showTooltip" effect="solid">
                        <FormattedMessage
                            id="scheduling_page.send_email.modal.send_email_message"
                            defaultMessage="Email sent!"
                        />
                    </ReactTooltip>
                    <div className="dropdown-menu" aria-labelledby="btnGroupScheduling">
                        {activeSchedulingPages.map(sp => {
                            return <a key={sp.id} className="dropdown-item" href="#" onClick={() => this.sendEmail(sp.id)}>
                                {sp.titleKeyword}
                            </a>
                        })}
                    </div>
                </div>)
        )
    }
}

export default SendSchedulingPageButton


// WEBPACK FOOTER //
// ./src/common/button/sendSchedulingPageButton.component.jsx